// For setting the attributes with "data-test=..." values in a consistent way;
// the scheme is 'filename-element-item', with each of filename/element/item
// being lowercase and 'having no spaces, no dashes
export function dataTestValue(filename, element, item) {
  return `${filename || 'unknown'}-${element || 'unknown'}-${item.replace(/[\s_]+/g, '') || 'unknown'}`.toLowerCase();
}
